import { authSlice } from "./slice";

export const { setTokenAndMe,setBlank, logout } = authSlice.actions;
